import { classNames } from "@lib/HtmlUtil"
import React from "react"

export enum ButtonType {
    Contained = "contained",
    Outlined = "outlined",
    Text = "text",
    Icon = "icon",
}

export enum ButtonTheme {
    Light = "light",
    Dark = "dark",
}

export type ButtonProps = {
    label?: string
    type?: ButtonType
    isEnabled?: boolean
    onClick?: () => void
    className?: string
    children?: React.ReactNode
    iconUrl?: string
    iconPosition?: "left" | "right"
    theme?: ButtonTheme
    tooltip?: string
    tabIndex?: number
}

export function Button({
    label,
    onClick,
    isEnabled = true,
    type = ButtonType.Contained,
    className,
    children,
    iconUrl,
    iconPosition,
    tooltip,
    theme = ButtonTheme.Dark,
    tabIndex,
}: ButtonProps): JSX.Element {
    if (iconPosition && iconUrl) {
        return (
            <button
                className={classNames(
                    "button",
                    isEnabled ? "button--enabled" : "button--disabled",
                    className
                )}
                data-button-type={type}
                data-button-theme={theme}
                data-icon-position={iconPosition}
                onClick={isEnabled ? onClick : undefined}
                {...(!isEnabled ? { disabled: true } : undefined)}
                {...(tooltip ? { title: tooltip } : undefined)}
                {...(tabIndex !== undefined ? { tabIndex } : undefined)}
            >
                {iconPosition === "left" && <img src={iconUrl} alt="" className="button__icon" />}
                {label}
                {children}
                {iconPosition === "right" && <img src={iconUrl} alt="" className="button__icon" />}
            </button>
        )
    }
    // Original behavior: untouched if iconPosition is not set
    return (
        <button
            className={classNames("button", isEnabled ? "button--enabled" : "button--disabled", className)}
            data-button-type={type}
            data-button-theme={theme}
            onClick={isEnabled ? onClick : undefined}
            {...(!isEnabled ? { disabled: true } : undefined)}
            {...(tooltip ? { title: tooltip } : undefined)}
            {...(tabIndex !== undefined ? { tabIndex } : undefined)}
            style={{ ...(iconUrl ? { backgroundImage: `url(${iconUrl})` } : {}) }}
        >
            {label}
            {children}
        </button>
    )
}

export function ButtonCont({ children, className }: { children?: React.ReactNode; className?: string }): JSX.Element {
    return <div className={classNames("button-cont", className)}>{children}</div>
}
